import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { fetchRating, rateIntervention, deleteRating, type InterventionRating, type RateInterventionBody } from '../api/interventionRatingApi';

const RATING_KEY = 'intervention-rating';

export const useInterventionRating = (issueKey: string, enabled = true) =>
  useQuery<InterventionRating | null>({
    queryKey: [RATING_KEY, issueKey],
    queryFn: () => fetchRating(issueKey),
    enabled: enabled && issueKey !== '',
    retry: false,
  });

export const useRateIntervention = (issueKey: string) => {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (body: RateInterventionBody) => rateIntervention(issueKey, body),
    onSuccess: () => qc.invalidateQueries({ queryKey: [RATING_KEY] }),
  });
};

export const useDeleteInterventionRating = (issueKey: string) => {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: () => deleteRating(issueKey),
    onSuccess: () => qc.invalidateQueries({ queryKey: [RATING_KEY] }),
  });
};
